var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5141_22218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.05879 0 0 8.05879 0 18C0 27.9411 8.05879 35.9999 18 35.9999C27.9411 35.9999 36 27.9411 36 18C35.9999 8.05879 27.941 0 18 0ZM13.1975 26.7021H9.24546V13.9341H13.1975V26.7021ZM11.2027 12.262C9.91196 12.262 8.86562 11.2072 8.86562 9.90611C8.86562 8.60492 9.91211 7.55012 11.2027 7.55012C12.4932 7.55012 13.5396 8.60492 13.5396 9.90611C13.5396 11.2072 12.4933 12.262 11.2027 12.262ZM28.0079 26.7021H24.075V20C24.075 18.1618 23.3768 17.1357 21.9233 17.1357C20.3414 17.1357 19.5149 18.2043 19.5149 20V26.7021H15.7244V13.9341H19.5149V15.6537C19.5149 15.6537 20.6551 13.5446 23.3625 13.5446C26.0699 13.5446 28.008 15.1978 28.008 18.6176L28.0079 26.7021Z",
    fill: "url(#paint0_linear_5141_22218)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5141_22218",
    x1: 5.27206,
    y1: 5.27206,
    x2: 30.7279,
    y2: 30.7279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2489BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0575B3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5141_22218"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.e89a89ea56e2c671e41a94eab8146f1c.svg";
export { ForwardRef as ReactComponent };